/**
 * Product List functionality.
 *
 * @module feature-productlist
 * @version 1.0.0
 * @author Peter van Gennip, peter.van.gennip@valtech.com
 */

import { Cookies } from 'foundation-theming';

const btnList = document.querySelector('.btn--list');
const btnGrid = document.querySelector('.btn--grid');
const productCards = document.querySelector('.hce-product-cards');
const btnProductFilterMobile = document.querySelector('.js-btn-productfilter-mobile');
const filtersContainer = document.querySelector('#filterscontainer');
const body = document.getElementsByTagName('body')[0];

/**
* get product-lister-cookie and init layout
*/
function initLayout() {
  // if layout is set to grid change classes
  if (Cookies.get('product-lister-layout') === 'grid-view') {
    btnGrid.classList.add('is-active');
    btnList.classList.remove('is-active');
    productCards.classList.add('is-grid');
    Cookies.set('product-lister-layout', 'grid-view');
  }
}

/**
 * Change layout in list or grid view on click.
 */
function toggleGridListView() {
  btnList.addEventListener('click', () => {
    btnList.classList.add('is-active');
    btnGrid.classList.remove('is-active');
    productCards.classList.remove('is-grid');
    Cookies.set('product-lister-layout', 'list-view');
  });

  btnGrid.addEventListener('click', () => {
    btnGrid.classList.add('is-active');
    btnList.classList.remove('is-active');
    productCards.classList.add('is-grid');
    Cookies.set('product-lister-layout', 'grid-view');
  });
}

/**
 * adds/removes class from body when product-lister-filters are open
 */
function togglBodyFiltersClass() {
  btnProductFilterMobile.addEventListener('click', () => {
    if (body.classList.contains('productfilters-open')) {
      body.classList.remove('productfilters-open');
    } else body.classList.add('productfilters-open');
  });
}

// toggle filters
function toggleFilters() {
  btnProductFilterMobile.addEventListener('click', (e) => {
    e.preventDefault();
    e.currentTarget.classList.toggle('is-active');
    $(filtersContainer).collapse('toggle');
  });
}

// on document ready
document.addEventListener('DOMContentLoaded', () => {
  initLayout();
  toggleGridListView();
  toggleFilters();
  togglBodyFiltersClass();
});
